import React, { FunctionComponent, JSX } from "react";
import cx from "classnames";
import styles from "./MenuItem.module.scss";
import { TabKeys } from "../../../data/tabs";
import { useMenu } from "../useMenu";

export interface MenuItemProps {
  title: string;
  icon: JSX.Element | false;
  disabled: boolean;
  tabKey?: TabKeys;
}

export const MenuItemComponent: FunctionComponent<MenuItemProps> = ({
  title,
  icon,
  disabled,
  tabKey,
}: MenuItemProps): JSX.Element => {
  const { selectedTab, onTabSelected } = useMenu();

  const onMenuItemTriggered = (): void => {
    if (tabKey) {
      onTabSelected(tabKey);
    }
  };

  return (
    <li
      className={cx(styles["menu-item"], {
        [styles["menu-item-active"] as string]:
          tabKey !== undefined && selectedTab === tabKey,
      })}
      onClick={onMenuItemTriggered}
      onKeyPress={onMenuItemTriggered}
      role="menuitem">
      <button
        className={cx(styles["button-menu"], {
          [styles["disabled"] as string]: disabled,
        })}>
        {icon && icon}
        {title}
      </button>
    </li>
  );
};
